(function () {
    console.log("Wizart script starting...");

    function initWizart() {
        try {
            console.log("Initializing Wizart...");

            const viewInRoomButton = document.querySelector(".view-in-room-btn");
            const modal = document.getElementById("wizart-modal");
            const closeModalButton = document.getElementById("wizart-close");
            const iframe = document.getElementById("wizart-iframe");
            const videoSectionButtons = document.querySelectorAll(".wizart-btn"); 

            // Ensure required elements exist
            if (!modal || !iframe || !closeModalButton) {
                console.error("Required DOM elements for Wizart integration are missing.");
                return;
            }

            // Open Modal Function
            function openModal(wizartCode) {
  console.log("Opening Wizart modal...", { wizartCode });

  const baseUrl = "https://wizart.ai/visualizer/casamonte_dXfQ";

  // If we have a code → open specific product
  // If not → open generic visualizer (browse mode)
  const url = wizartCode
    ? `${baseUrl}?sku=${encodeURIComponent(wizartCode)}`
    : baseUrl;

  iframe.src = url;

  modal.style.display = "block";
  requestAnimationFrame(() => {
    modal.style.visibility = "visible";
    modal.style.opacity = "1";
  });
}


            // Close Modal Function
            function closeModal() {
                console.log("Closing Wizart modal...");
                
                modal.style.opacity = "0";
                modal.style.visibility = "hidden";
                
                setTimeout(() => {
                    modal.style.display = "none";
                    
                    // Reset iframe (Optional: Prevents unnecessary resource usage)
                    if (iframe) {
                        iframe.src = "about:blank";
                    }
                }, 300);
            }

            // Attach Event Listeners for Buttons
            if (viewInRoomButton) {
                viewInRoomButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    openModal();
                });
            }

            videoSectionButtons.forEach((button) => {
                button.addEventListener("click", (e) => {
                    e.preventDefault();
                    openModal();
                });
            });

            // Close Modal on Close Button Click
            closeModalButton.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                closeModal();
            });

            // 🔹 Close Modal When Clicking Outside of the Visualizer
            modal.addEventListener("click", (e) => {
                if (e.target === modal) {
                    closeModal();
                }
            });

            // Close Modal on Escape Key Press
            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape" && modal.style.visibility === "visible") {
                    closeModal();
                }
            });

            console.log("Wizart modal functionality initialized.");
        } catch (error) {
            console.error("Error initializing Wizart script:", error);
        }
    }

    // Initialize Wizart when the DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initWizart);
    } else {
        initWizart();
    }
})();
